module.exports = __webpack_public_path__ + "static/media/parallel-sets.b7ba96c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/parallel-sets.png
// module id = 48
// module chunks = 0